export default "__VITE_ASSET__55cc9f55__"